import { gsap } from 'gsap'
import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class AboutSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');
    this.dom.bg = document.querySelectorAll('[data-js="special-bg"]');

    this.dom.page = this.dom.el.querySelector('.splide-page')
    this.dom.current = this.dom.el.querySelector('.splide-page__current')
    this.dom.total = this.dom.el.querySelector('.splide-page__total')

    this.total = null;
    this.rate = null;

    this.currentBg = 0;

    this.slider = null;
    this.option = {
      autoplay: false,
      type: 'fade',
      perPage: 1,
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      interval: 5000,
      speed: 2000,
      arrows: false,
      pagination: false,
      gap: `min(${16 / 16}rem, ${16 / 360 * 100}vw)`,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          arrows: true,
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.dom.progress = this.slider.root.querySelector('.splide-carousel-progress-bar');
    this.slider.on('mounted move', () => {
      this.total  = this.slider.Components.Controller.getEnd() + 1;
      this.rate = Math.min( ( this.slider.index + 1 ) / this.total, 1 );
      this.setPage();
    } );
    this.slider.on('move', () => {
      this.changeBg();
    } );
    this.slider.mount();
    
    gsap.set(this.dom.bg[0], {
      opacity: 1
    })
  }
  
  setPage() {
    this.dom.current.textContent = this.rate * this.total;
    this.dom.total.textContent = `/ ${this.total}`;
  }
  
  changeBg() {
    const showIndex = this.rate * this.total - 1;
    const hideIndex = this.currentBg;
    // console.log({showIndex, hideIndex});
    gsap.to(this.dom.bg[showIndex], {
      opacity: 1,
      ease: 'power1.inOut'
    })
    gsap.to(this.dom.bg[hideIndex], {
      opacity: 0,
      ease: 'power1.inOut'
    })
    this.currentBg = showIndex;
  }
}

export default AboutSlides